import {
	createBrowserRouter,
	createRoutesFromElements,
	Route,
	RouterProvider,
	useParams,
	BrowserRouter as Router, Routes, useLocation, Navigate, useNavigate
} from 'react-router-dom'

import {
	Link
} from '@chakra-ui/react';

import {PropsWithChildren, ReactElement, ReactNode, useEffect, useState} from 'react';

import {useEvoContext} from "./context/evo.context";


// layout
import RootLayout from './components/layout/RootLayout';

/* stranky */
import Main from './components/screens/Main';
import Purchase from './components/screens/Purchase';
import Read from './components/screens/Read';
import ReadPublic from './components/screens/ReadPublic';
import Login from './components/screens/Login';
import Profile from './components/screens/Profile';
import Register  from './components/screens/Register';
// import Conditions  from './components/screens/Conditions';
// import BankTransferInfo  from './components/screens/BankTransferInfo';
import {JournalList}  from './components/screens/JournalList';
import {JournalListTabs}  from './components/screens/JournalListTabs';
import JournalListTabsPublic  from './components/screens/JournalListTabsPublic';
import JournalListPublic  from './components/screens/JournalListPublic';
import PasswordReset  from './components/screens/PasswordReset';
import {PurchaseConfirmation}  from './components/screens/PurchaseConfirmation';
import CodeActivation  from './components/screens/CodeActivation';
import {SubscriptionActivated} from './components/screens/PurchaseByCodeConfirmation';
import {RegistrationConfirmation} from './components/screens/RegistrationConfirmation';
import PasswordChange from "./components/screens/PasswordChange"


import {PaymentByCardStates, PAYMENT_STATE_PAYED, PAYMENT_STATE_CANCELED, PAYMENT_STATE_PENDING}  from './components/screens/PaymentByCardStates';

/* routes */
export const ROUTE_MAIN = '/';
export const ROUTE_PURCHASE = 'predplatne';
export const ROUTE_READ_PART = 'vydani/';
export const ROUTE_READ = ROUTE_READ_PART + ':id_issue?/:page?';
export const ROUTE_READ_PUBLIC = ROUTE_READ_PART + ':id_issue?/verejne';
export const ROUTE_READ_PUBLIC_OLD = ROUTE_READ_PART + 'verejne/:id_issue?';
export const ROUTE_LOGIN = 'prihlaseni';
export const ROUTE_REGISTRATION = 'registrace';
export const ROUTE_PROFILE = 'profil';
export const ROUTE_PASSWORD_CHANGE = 'zmena-hesla';
//export const ROUTE_PERSONAL_DATA_PROCESSING = 'podminky-zpracovani-udaju';
export const ROUTE_PASSWORD_RESET = 'reset-hesla';
// export const ROUTE_PURCHASE_CONFIRMATION = 'potvrzeni-objednavky';
export const ROUTE_PURCHASE_CONFIRMATION_PART = 'predplatne/objednavka/';
export const ROUTE_PURCHASE_CONFIRMATION = ROUTE_PURCHASE_CONFIRMATION_PART + ':orderId?';

export const ROUTE_CODE_ACTIVATION = 'aktivace';
export const ROUTE_CODE_ACTIVATION_CONFIRMATION = 'aktivace-potvrzeni';
export const ROUTE_ISSUE_LIST = 'vydani/casopisy';
export const ROUTE_ISSUE_LIST_PUBLIC = 'vydani/archiv';

export const ROUTE_PAYMENT_GATEWAU_PAID = 'platebni-brana/comgate/status/paid/:id?/:refId?';
export const ROUTE_PAYMENT_GATEWAU_CANCELED = 'platebni-brana/comgate/status/cancelled/:id?/:refId?';
export const ROUTE_PAYMENT_GATEWAU_PENDING = 'platebni-brana/comgate/status/pending/:id?/:refId?';
export const ROUTE_REGISTRATION_CONFIRMATION = 'registrace/potvrzeni/:poid?';


/*
platebni-brana/comgate/status/paid/${id}/${refId}
platebni-brana/comgate/status/cancelled/${id}/${refId}
platebni-brana/comgate/status/pending/${id}/${refId}
 */

/* params */
export const ROUTE_PARAM_ISSUE = 'casopis';
export const ROUTE_PARAM_ORDER = 'objednavka';

interface ProtectedRouteProps {
	children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const { isLoggedIn, loading} = useEvoContext();

	if (loading) {
		return <div>Loading...</div>; // Show a loading spinner or placeholder
	}

	if (!isLoggedIn) {
		return <Navigate to={ROUTE_MAIN + ROUTE_LOGIN} />;
	}

	return <>{children}</>; // Wrap children in a Fragment to ensure it is a valid JSX element
};



interface NormalizeSlashProps {} // Define props for NormalizeSlash if needed

const NormalizeSlash: React.FC<NormalizeSlashProps> = ({ children }) => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (location.pathname.endsWith("/") && location.pathname !== "/") {
			navigate(location.pathname.slice(0, -1), { replace: true });
		}
	}, [location, navigate]);

	return <>{children}</>;
};


const RootWrapper = () => {
	return (
		<div>
			<RootLayout />
		</div>
	);
};


const NotFound = () => {
	return (
		<div style={{ textAlign: 'center', marginTop: '50px' }}>
			<h1>404 Nenalezeno</h1>
			<p>Omlouváme se, ale stránka, kterou hledáte, neexistuje.</p>
			<Link href={ROUTE_MAIN} style={{ color: 'blue', textDecoration: 'underline' }}>
				Zpět na domovskou stránku
			</Link>
		</div>
	);
};

const RedirectIssueWithParams = () => {
	const { id_issue } = useParams();
	const targetRoute = `${ROUTE_MAIN +  ROUTE_READ_PART}${id_issue}${'/verejne'}`;

	return <Navigate to={targetRoute} replace />;
};

// router and routes
const router = createBrowserRouter(
	createRoutesFromElements(
		<Route path={ROUTE_MAIN} element={/*<NormalizeSlash>*/<RootWrapper />/*</NormalizeSlash>*/}>
			<Route index element={<Main />} />
			<Route path={ROUTE_PURCHASE} element={<Purchase />} />
			{/*<Route path={ROUTE_READ} element={<Read publicIssue={false} />} />*/}
			<Route path={ROUTE_READ} element={<ProtectedRoute><Read publicIssue={false} /></ProtectedRoute>} />
			<Route path={ROUTE_READ_PUBLIC} element={<ReadPublic />} />
			<Route path={ROUTE_LOGIN} element={<Login />} />
			<Route path={ROUTE_REGISTRATION} element={<Register />} />
			<Route path={ROUTE_PROFILE} element={<ProtectedRoute><Profile /></ProtectedRoute> }/>

			<Route path={ROUTE_READ_PUBLIC_OLD} element={<RedirectIssueWithParams />} />
			{/*<Route path={ROUTE_READ_PUBLIC_OLD} element={<Navigate to={ROUTE_MAIN + ROUTE_READ_PUBLIC} replace />} />*/}

			{/*<Route path={ROUTE_PROFILE} element={<Profile />}/>*/}
			{/*<Route path="podminky-zpracovani-udaju" element={<Conditions />}  />*/}
			{/*<Route path="bankovni-prevod" element={<BankTransferInfo />}  />*/}
			<Route path={ROUTE_ISSUE_LIST} element={<JournalListTabs />}  />
			<Route path={ROUTE_ISSUE_LIST_PUBLIC} element={<JournalListTabsPublic />}  />
			<Route path={ROUTE_PASSWORD_RESET} element={<PasswordReset />}  />
			<Route path={ROUTE_PASSWORD_CHANGE} element={<ProtectedRoute><PasswordChange /></ProtectedRoute> }/>
			<Route path={ROUTE_PURCHASE_CONFIRMATION} element={<PurchaseConfirmation />}  />
			<Route path={ROUTE_CODE_ACTIVATION} element={<CodeActivation />}  />
			<Route path={ROUTE_CODE_ACTIVATION_CONFIRMATION} element={<SubscriptionActivated />}  />
			<Route path={ROUTE_PAYMENT_GATEWAU_PAID} element={<PaymentByCardStates outcome={PAYMENT_STATE_PAYED} />}  />
			<Route path={ROUTE_PAYMENT_GATEWAU_CANCELED} element={<PaymentByCardStates outcome={PAYMENT_STATE_CANCELED} />}  />
			<Route path={ROUTE_PAYMENT_GATEWAU_PENDING} element={<PaymentByCardStates outcome={PAYMENT_STATE_PENDING} />}  />
			<Route path={ROUTE_REGISTRATION_CONFIRMATION} element={<RegistrationConfirmation />}  />
			<Route path="*" element={<NotFound />} />
		</Route>
	)
)

function App() {

	return (
		<RouterProvider router={router} />
	)
}



export default App